import { render } from "./dm_conv_recipients.vue?vue&type=template&id=e0770c6c"
import script from "./dm_conv_recipients.js?vue&type=script&lang=js&external"
export * from "./dm_conv_recipients.js?vue&type=script&lang=js&external"

import "./dm_conv_recipients.vue?vue&type=style&index=0&id=e0770c6c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__